import React from "react";
import { getShowTime } from "shared/utils/showDateTimeDisplay";

interface Props {
  dateTime: server.dto.AppointmentDateTime
}

const ShowTime = (props: Props) => {
  const display = getShowTime(props.dateTime);

  if (display.kind === "none") {
    return null;
  }

  if (display.kind === "fallback") {
    return <span className="s1_blue s1_small">{display.text}</span>;
  }

  if (display.kind === "single") {
    return <span className="s1_small">{display.start}</span>;
  }

  if (display.deEmphasizeEnd) {
    return <span className="s1_small">{display.start}&nbsp;-&nbsp;<span className="s1_gray">{display.end}</span></span>;
  }

  return <span className="s1_small">{display.start}&nbsp;-&nbsp;{display.end}</span>;
};

export default ShowTime;
